// 客户端-INTLSDK成功率错误码 英文配置
export default {
  // 页面标题
  "error_code_title": "Success Rate And Error Code",

  // 筛选器
  'error_code_filter_app_version_label': 'APP Version',
  'error_code_filter_app_version_info': '',
  'error_code_filter_app_version_des': 'All',
  'error_code_filter_error_code_label': 'Error Code',
  'error_code_filter_error_code_info': '',
  'error_code_filter_error_code_des': 'All',
  'error_code_filter_count_label': 'Count',
  'error_code_filter_count_info': 'The Count filter option determines the statistics logic of the page',

  // Login Success Rate 模块
  "error_code_login_success_rate": "Login Success Rate",
  "error_code_exclude_uer_canceled": "Exclude User Canceled",

  // Overview 表格
  "error_code_overview": "Overview",
  "error_code_login_success_device": "Login Success Device",
  "error_code_initiate_login_device": "Initiate Login Device",
  "error_code_share_of_login_success_device": "Share of Login Success Device",
  "error_code_login_success_count": "Login Success Count",
  "error_code_initiate_login_count": "Initiate Login Count",
  "error_code_share_of_login_success_count": "Share of Login Success Count",


  // Error Code 模块
  "error_code_error_code": "Error Code",
  "error_code_error_code_share": "Error Code Share",
  "error_code_error_code_trends": "Error Code Trends",
  "error_code_count": "Count",
  "error_code_device": "Device",
  // 表格列
  "error_code_error_code_device": "Error Code Device",
  "error_code_error_code_count": "Error Code Count",
  "error_code_share_of_error_device": "Share of Error Device",
  "error_code_share_of_error_count": "Share of Error Count",




  // Error Code Breakdown 表格
  "error_code_error_code_breakdown": "Error Code Breakdown",
  "error_code_error_message_from_the_third": "Error Message From The Third",
  "error_code_device_of_error_message_from_the_third": "Device of Error Message From The Third",
  "error_code_count_of_error_message_from_the_third": "Count of Error Message From The Third",
  "error_code_share_of_the_third_error_device": "Share of The Third Error Device",
  "error_code_share_of_the_third_error_count": "Share of The Third Error Count",


  // 下钻页面
  "error_code_key_metrics_ranking": "Key Metrics Ranking",

  // 国家/区域排行榜
  "error_code_country_region_breakdown": "Country/Region Breakdown",
  "error_code_country": "Country",
  "error_code_region": "Region",
  "error_code_top10_country": "Top 10 Countries",
  "error_code_top10_region": "Top 10 Region",


}
